/**
 * Die Jira-Instanz benennt Prioritäten numerisch ("1"–"4"). Fürs Kunden-UI
 * mappen wir auf sprechende Labels — einzige Stelle, leicht änderbar.
 * Unbekannte Namen (z. B. bereits sprechende) laufen unverändert durch.
 */
const LABELS: Record<string, string> = {
  "1": "Sehr hoch",
  "2": "Hoch",
  "3": "Mittel",
  "4": "Niedrig",
};

export function priorityLabel(name: string | null | undefined): string {
  if (!name) return "";
  return LABELS[name] ?? name;
}
